var _style, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightPinkSphere(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3.9 3.9",
    style: {
      enableBackground: "new 0 0 3.9 3.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n")), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 2.448,
    cy: 1.4063,
    r: 2.7057,
    fx: 3.3222,
    fy: 0.6584,
    gradientTransform: "matrix(1 0 0 0.9308 0 9.737101e-02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.218,
    style: {
      stopColor: "#FF79AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4226,
    style: {
      stopColor: "#CF629E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8196,
    style: {
      stopColor: "#783781"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#552676"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1.9,
    cy: 1.9,
    r: 1.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightPinkSphere);
export default __webpack_public_path__ + "static/media/light-pink-sphere.509cc1d1cd6bb60f14278af6aeaff8c7.svg";
export { ForwardRef as ReactComponent };